import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { MemberContext } from '../../../../context/member-context';

const EventItem = ({ data }) => {
  const { events } = useContext(MemberContext);
  let text = '';
  let link = '';

  if (data.section === 'comment') {
    text = <span className="font-size-4 line-height-3">به نظر شما پاسخ داده شد.</span>;
    link = `/post/${data.section_dependency}`;
  } else if (data.section === 'post') {
    text = (
      <span className="font-size-4 line-height-3">
        <span className="font-weight-bold font-size-4">پست جدید</span> در دسته بندی{' '}
        <span className="font-weight-bold font-size-4">{data.category_name}</span> منتشر شد.
      </span>
    );
    link = `/post/${data.section_id}`;
  }

  const handleSeen = () => {
    if (parseInt(data.seen) === 0) {
      events.eventSeen(data.id);
    }
  };

  return (
    <li
      className={`list-item close-menu ${parseInt(data.seen) === 0 ? 'circle-highlight-right' : ''}`}
      onClick={handleSeen}
    >
      <Link to={link} className="d-flex f-column">
        {text}
        <span className="ltr text-left color-gray font-size-2 font-weight-300 letter-spacing-2">{data.date_added}</span>
      </Link>
    </li>
  );
};

export default React.memo(EventItem);
